import {
    fetchResellerCoverageReport,
    fetchResellerCoverageItems,
    FetchResellerCoveragePayload,
    FetchResellerCoverageItemsPayload,
} from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ResellerCoverageKeys = {
    all: ['resellerCoverageReport'] as const,
    list: (payload: FetchResellerCoveragePayload) => [...ResellerCoverageKeys.all, payload] as const,
    items: (payload: FetchResellerCoverageItemsPayload) => [...ResellerCoverageKeys.all, 'items', payload] as const,
}

export const useResellerCoverageReportQuery = (
    payload: FetchResellerCoveragePayload = {},
    options?: { enabled?: boolean }
) => {
    return useQuery({
        queryFn: () => fetchResellerCoverageReport(payload),
        queryKey: ResellerCoverageKeys.list(payload),
        enabled: options?.enabled ?? true,
    })
}

export const useResellerCoverageItemsQuery = (payload: FetchResellerCoverageItemsPayload | null) => {
    return useQuery({
        queryFn: () => fetchResellerCoverageItems(payload!),
        queryKey: ResellerCoverageKeys.items(payload!),
        enabled: Boolean(payload && payload.SK_PESQUISA && payload.SK_REVENDA),
    })
}
